interface PlaceholderProps {
  title: string;
  hint: string;
}

export function Placeholder({ title, hint }: PlaceholderProps) {
  return (
    <div className="p-8">
      <h2 className="mb-2 text-2xl font-semibold">{title}</h2>
      <p className="text-zinc-400">{hint}</p>
    </div>
  );
}
